
import React from "react";
import {ILatencyWrapper} from "../interfaces";
import SearchFilter from "./search-filter";
import {useAppSelector} from "../../product-page/data-services/store";
import {ProductTypeEnum} from "../../product-page/data-services/data-service";


export interface ITabLatencyProps {
    latencyWrapper?:ILatencyWrapper
}
/**
 * the entry point
 */
const TabLatency = (props?: ITabLatencyProps) => {

    let latencyWrapper = props?.latencyWrapper;
    const techSpecsSearchPlugins = useAppSelector((store) => store.techSpecsSearchPlugins);
    const productDataType = useAppSelector((store) => store.productDataType);

    const getTDValue = (val1 : string | null, val2 : string | null, val1Title: string, val2Title: string) => {
        if(val1 === val2)
            return <div dangerouslySetInnerHTML={{ __html: val1 ?? "" }} />
        else
        {
            return <div>{val1Title}<span dangerouslySetInnerHTML={{ __html: val1 ?? "" }} /> <br />{val2Title}<span dangerouslySetInnerHTML={{ __html: val2 ?? "" }} /></div>;
        }
    };

    return (
        <div className="my-4">
            {latencyWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: latencyWrapper?.topBanner }} />}

            {latencyWrapper != null && latencyWrapper.latency.length > 0 &&
                <table className="table-fixed w-full text-base mt-8 rounded">
                    <thead style={{position:productDataType !== ProductTypeEnum.plugin ? "sticky" : "unset",top:(latencyWrapper.topPosition && latencyWrapper.topPosition !== null) ? latencyWrapper.topPosition : "136px"}}>
                    {productDataType !== ProductTypeEnum.plugin &&  <tr>
                        <td className="bg-white" colSpan={10} >
                            <SearchFilter />
                        </td>
                    </tr>}
                    <tr className="h-10 bg-gray-400">
                        <td className="font-bold border pl-4">&nbsp;</td>
                        <td colSpan={3} className="font-bold border text-center-webkit">NATIVE / SOUNDGRID</td>
                        <td className="font-bold border text-center-webkit">VENUE TDM</td>
                    </tr>
                    <tr className="h-20 bg-gray-150">
                        <td className="font-bold border pl-4">Plugin</td>
                        <td className="font-bold border text-center-webkit">44.1 kHz - 48 kHz</td>
                        <td className="font-bold border text-center-webkit">88.2 kHz - 96 kHz</td>
                        <td className="font-bold border text-center-webkit">176.4 kHz - 192 kHz</td>
                        <td className="font-bold border text-center-webkit">48 kHz</td>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        latencyWrapper?.latency?.filter(s=>s.documentName.toLowerCase().includes(techSpecsSearchPlugins.toLowerCase())).map((l, index) => {
                            return (
                                <tr key={ index }
                                    className="w-full h-20">
                                    <td className="border pl-4">{l.documentName}</td>
                                    <td className="border text-center-webkit p-2">
                                        {getTDValue(l.native44, l.native48, "44.1 kHz:", "48 kHz:")}
                                    </td>
                                    <td className="border text-center-webkit p-2">
                                        {getTDValue(l.native88, l.native96, "88.2 kHz:", "96 kHz:")}
                                    </td>
                                    <td className="border text-center-webkit p-2">
                                        {getTDValue(l.native176, l.native192, "176.4 kHz:", "192 kHz:")}
                                    </td>
                                    <td className="border text-center-webkit p-2">
                                        <span dangerouslySetInnerHTML={{ __html: l.tdM48 ?? "" }} />
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            }
            {latencyWrapper != null && <div className={"my-8"} dangerouslySetInnerHTML={{ __html: latencyWrapper?.bottomBanner }} />}
        </div>
    )
};

export default TabLatency;